import { createReducer, on } from '@ngrx/store';
import { EMPTY_USER_PROFILE, UserProfile } from './user.datamodel';

import * as UserActions from './user.actions';
import * as LoginActions from '../login/store/login.actions';
import { updateObject } from '../shared/reducers/reducer-utils';

export const USER_FEATURE = 'userReducer';

export interface UserState {
  user: UserProfile;
}

export const userInitialState: UserState = {
  user: EMPTY_USER_PROFILE
};

export const userReducer = createReducer(
  userInitialState,
  on(LoginActions.LoginCompleted, (state, { jsessionId }) => {
    return {
      ...state,
      user: {
        ...state.user,
        jsessionId: jsessionId ?? ''
      }
    };
  }),
  on(UserActions.ActorsInContextRetrieved, (state, { actorsInContext }) => {
    return {
      ...state,
      user: updateObject(state.user, {
        userId: actorsInContext.userId ?? '',
        officeId: actorsInContext.officeId ?? '',
        organizationId: actorsInContext.organizationId ?? ''
      })
    };
  }),
  on(UserActions.UserRFDRetrieved, (state, payload) => {
    return {
      ...state,
      user: updateObject(state.user, {
        firstName: payload.firstName ?? '',
        lastName: payload.lastName ?? ''
      })
    };
  })
);
